import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { PagesComponent } from './pages/pages.component';
import { NotFoundComponent } from './pages/errors/not-found/not-found.component';
import { ErrorComponent } from './pages/errors/error/error.component';
import { UnauthorizedComponent } from './pages/errors/unauthorized/unauthorized.component';
import { RouteGuard } from './shared/guards/route.guard';
import { MenuResolverService } from './shared/services/menu-resolver.service';
import { SigninRedirectCallbackComponent } from './pages/home/signin-redirect-callback/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './pages/home/signout-redirect-callback/signout-redirect-callback.component';
import { CheckoutRedirectCallbackComponent } from './pages/home/checkout-redirect-callback/checkout-redirect-callback.component';
import { EmailAlreadyRegisteredComponent } from './pages/errors/email-already-registered/email-already-registered.component';

export const routes: Routes = [
	{ path: 'error', component: ErrorComponent },
	{ path: 'unauthorized', component: UnauthorizedComponent },
	{ path: 'email-already-registered', component: EmailAlreadyRegisteredComponent },
	{ path: 'signin-callback', component: SigninRedirectCallbackComponent, data: { allowPublic: true } },
	{ path: 'signout-callback', component: SignoutRedirectCallbackComponent, data: { allowPublic: true } },
	{ path: 'checkout-redirect', component: CheckoutRedirectCallbackComponent, data: { allowPublic: true } },
	{
		path: '', component: PagesComponent, resolve: { userProfile: MenuResolverService }, canActivateChild: [RouteGuard], data: { allowPublic: true }
		, children: [
			{ path: '', loadChildren: () => import('./pages/features/features.module').then(m => m.FeaturesModule), data: { allowPublic: true } },
			{ path: 'features', loadChildren: () => import('./pages/features/features.module').then(m => m.FeaturesModule), data: { allowPublic: true } },
			{ path: 'pricing', loadChildren: () => import('./pages/pricing/pricing.module').then(m => m.PricingModule), data: { allowPublic: true } },
			{ path: 'contact', loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule), data: { allowPublic: true } },
			{ path: 'trackinator', loadChildren: () => import('./pages/trackinator/trackinator.module').then(m => m.TrackinatorModule) },
			{ path: 'admin', loadChildren: () => import('./pages/admin/admin.module').then(m => m.AdminModule) },
			{ path: 'unauthorized', component: UnauthorizedComponent, data: { allowPublic: true } },
			// { path: '**', component: NotFoundComponent }
		]
	},
	{ path: '**', component: NotFoundComponent, data: { allowPublic: true } }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            // preloadingStrategy: PreloadAllModules, // <- comment this line for activate lazy load
            relativeLinkResolution: 'corrected',
            // relativeLinkResolution: 'legacy',
            // useHash: true
        })
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule { }